import React from 'react';
import styles from './Dropdown.css';

export const DropdownDivider = React.memo((props) => (
    <li className = {styles.divider}>{props.children}</li>
));
